import React from 'react';
import QuestionPanel from "../../structure/QuestionPanel";
import AddListElementButton from "../../button/AddListElementButton";
import DateRange from "../../input/DateRange";
import SelectDropdown from "../../input/SelectDropdown";
import { findClaimDateFor } from "../../enums/BenefitType";
import { FormValues } from "../../common/FormValues";
import { useFormikContext } from "formik";

const ClaimDates = () => {
    const { values } = useFormikContext<FormValues>();
    const leaveTimeframe = SelectDropdown({
        id: "leave-timeframe",
        label: "Leave timeframe",
        required: true,
        options: [
            {id: "continuous", text: "Continuous"},
            {id: "periodic", text: "Periodic"}
        ]
    });

    const claimDateText = findClaimDateFor(values.benefit);
    const noLeaveTimeframe = leaveTimeframe === null;
    return (
        <QuestionPanel headerText={claimDateText.headerText}
                       detailsText={claimDateText.detailsText}
                       panelContent={
                           <div>
                               {leaveTimeframe}
                               {noLeaveTimeframe
                                   ? <DateRange idPrefix="claim-dates" index={0} startLabel={claimDateText.startDateLabel}/>
                                   : <AddListElementButton idPrefix="claim-dates" componentType={DateRange}
                                                           elementInitialValue={{ startDate: '', endDate: '' }}
                                                           label=""
                                                           buttonText="Add Date Range"/>
                               }
                           </div>}
        >
        </QuestionPanel>
    )
};
export default ClaimDates;